<template lang="pug">
    article#cursosGratuitos
        Banner(@jasoualuno="aside = true")
        Aside(:ativo="aside", @close="aside = false")
        Juntos
        Inscricao(titulo="Inscrições Encerradas!", subtitulo="", :hasForm="false")
</template>

<script>
import Banner from '@sections/CursosGratuitos/Banner/Banner.vue'
import Aside from '@sections/CursosGratuitos/Aside/Aside.vue'
import Juntos from '@sections/CursosGratuitos/Juntos/Juntos.vue'
import Inscricao from '@components/Inscricao/Inscricao.vue'

export default {
    name: "view-cursos-gratuitos",
    components: {
        Banner,
        Aside,
        Juntos,
        Inscricao
    },
    data() {
        return {
            aside: false
        }
    },
}
</script>

<style lang="stylus" scoped src="./CursosGratuitos.styl"></style>